/**
 * Shared mutable state objects used across modules.
 *
 * These are extracted into a dependency-free module to break circular
 * dependency chains (e.g. util ↔ scroll-helpers ↔ more-articles,
 * scroll-helpers ↔ modal-image). ES module bindings on objects are
 * read-only, but mutating properties on the object works fine.
 */

/** Scroll animation state — set by tdUtil.scrollToPosition, read by more-articles / modal-image */
export var tdScrollState = { tdIsScrollingAnimation: false };

/** Modal image state — set by scroll-helpers, read by modal-image */
export var tdModalImageState = { lastEl: '' as any };
